<template>
    <v-snackbar
        v-model="enabled"
        :color="color"
        :timeout="timeout"
        min-width="300px"
        top
        centered
        elevation="24"
        vertical
    >
        <strong style="white-space:pre-line; word-wrap:break-word;">
            {{ message}}
        </strong>
        <template v-slot:action>
            <v-btn
            icon
            @click="close"
            >
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
	name: 'Snackbar',
    data () {
        return {
            enabled: false,
            message: '',
            type: 'success',
            timeout: 7000,
            typeColorList: {
                success: "success",
                error: "error",
                info: "primary",
                '': "disabled"
            }
        }
    },
    created () {
        this.$bus.$on('snackbar:success', (message) => {
            this.timeout = 5000;
            this.open(message, 'success');
        })
        this.$bus.$on('snackbar:error', (message) => {
            this.timeout = -1;
            this.open(message, 'error');
        })
        this.$bus.$on('snackbar:info', (message) => {
            this.timeout = 5000;
            this.open(message, 'info');
        })
    },
    computed: {
        color() {
            return this.typeColorList[this.type];
        }
    },
    methods: {
        open(message, type){
            this.message = message;
            this.type = type;
            this.enabled = true;
        },
        close(){
            this.enabled = false;
            this.message = '';
        }
    }
}
</script>
